<template>
  <div v-if="user.devActive" class="debug">
    <div class="flex-row flex-space-between m-2xs-b">
      <b>DEBUG</b>
      <div class="hide-button" @click="hideThis">hide this</div>
    </div>
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { useUserStore } from "@/stores/user";

const user = useUserStore();

function hideThis() {
  user.devActive = false;
}
</script>

<style scoped>
.debug {
  opacity: 0.9em;
  border: 1px solid black;
  background: linear-gradient(-45deg, #ddd, #eee);
  margin: 0.5em;
  padding: 0.5em;
  border-radius: 0.25em;
  font-family: "Courier New", Courier, monospace;
}
.debug .flex-row {
  font-size: 12px;
  display: block;
}
</style>
